import { Meteor } from 'meteor/meteor';
import { ValidatedMethod } from 'meteor/mdg:validated-method';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';
import { DDPRateLimiter } from 'meteor/ddp-rate-limiter';
import _ from 'lodash';
import moment from 'moment';

import { Reservations } from '../reservations/reservations';

export const reservationsStatistics = new ValidatedMethod({
	name: 'reservations.statistics',
	validate: new SimpleSchema({
		from: { type: String },
		to: { type: String },
		affichage: { type: String }
	}).validator(),
	run({ from, to, affichage }) {

    	let startOf = affichage.slice(0, -1);
        let dataAngers = [];
        let dataNantes = [];
        let dataAll = [];

        for(let i = 0; i <= moment(to).diff(moment(from), affichage); i++) {

            let startDate = moment(from).startOf(startOf).add('1', 'hours').add(i, affichage).toDate();
            let endDate = moment(from).endOf(startOf).add(i, affichage).toDate();

            if(i == 0) {
            	startDate = moment(from).toDate();
            }

            if(i == moment(to).diff(moment(from), affichage)) {
            	let endDate = moment(to).toDate();
            }

            dataAll.push(Reservations.find({createdAt: {$gte: startDate, $lte: endDate}, billAt: {$ne: ""}}).fetch().length);
            dataAngers.push(Reservations.find({createdAt: {$gte: startDate, $lte: endDate}, billAt: {$ne: ""}, place: "anjou"}).fetch().length);
            dataNantes.push(Reservations.find({createdAt: {$gte: startDate, $lte: endDate}, billAt: {$ne: ""}, place: "nantes"}).fetch().length);
        }

		return [
			dataAll,
			dataAngers,
			dataNantes
		];
	}
});

export const reservationsExport = new ValidatedMethod({
	name: 'reservations.export',
	validate: new SimpleSchema({
		'selectedYear': {type: String}
	}).validator(),
	run({ selectedYear }) {

        let datas = [];
				let startDate = moment().year(selectedYear).startOf('year').toDate();
				let endDate = moment().year(selectedYear).endOf('year').toDate();

				let reservations = Reservations.find({createdAt: {$gte: startDate, $lte: endDate}}).fetch();

				_.each(reservations, (reservation) => {

						let souscripteur = reservation.getSubscriber();
						let passengers = reservation.getPassengers();

						let emails = [];
						let phones = [];

						_.each(passengers, (passenger) => {
							if(passenger.email && passenger.email.length > 3) {
								emails.push(' ' + passenger.email + ' ');
							}
							if(passenger.phone) {
								phones.push(' ' + passenger.phone + ' ');
							}
						})

						if(reservation.id_billet) {
							datas.push({
								'N° Billet': reservation.id_billet,
								'Emails passagers': emails,
								'Téléphones passagers': phones,
								'Email acheteur': (souscripteur) ? souscripteur.email : '-',
								'Date achat': moment(reservation.createdAt).format('D/M/Y'),
								'Prestation': reservation.flightName,
								'Status': reservation.getState(),
								'Date vol': (reservation.scheduledAt) ? moment(reservation.scheduledAt).format('D/M/Y') : '-',
								'Passagers': passengers.length,
								'Lieu envol': reservation.getPlace(),
								'Type': reservation.flightName,
								'Adresse': (souscripteur) ? souscripteur.city : '-',
								'Prix': reservation.getPrice(),
								'Payée': (reservation.price <= reservation.getSolde()) ? 'Oui' : 'Non',
								'Periode': reservation.period,
								'Informations': (reservation.infoReservation) ? reservation.infoReservation.replace(/;/g, ',') : '-',
							});
						}

				});

		return datas;
	}
});


export const reservationsCancelExport = new ValidatedMethod({
	name: 'reservationsCancel.export',
	validate: new SimpleSchema({
		'selectedYear': {type: String}
	}).validator(),
	run({ selectedYear }) {

        let datas = [];
				let startDate = moment().year(selectedYear).startOf('year').toDate();
				let endDate = moment().year(selectedYear).endOf('year').toDate();

				let reservations = Reservations.find(
					{state: {$lt: 6},
            history: { $elemMatch: {
              date: {$gte: startDate, $lte: endDate},
              type: 'cancelled'
            }
          }}).fetch();

				_.each(reservations, (reservation) => {

						let souscripteur = reservation.getSubscriber();
						let passengers = reservation.getPassengers();

						let emails = [];
						let phones = [];

						_.each(passengers, (passenger) => {
							if(passenger.email && passenger.email.length > 3) {
								emails.push(' ' + passenger.email + ' ');
							}
							if(passenger.phone) {
								phones.push(' ' + passenger.phone + ' ');
							}
						})

						if(reservation.id_billet && reservation.getCancelTime() > 0) {
							datas.push({
								'N° Billet': reservation.id_billet,
								'Emails passagers': emails,
								'Téléphones passagers': phones,
								'Email acheteur': (souscripteur) ? souscripteur.email : '-',
								'Date achat': moment(reservation.createdAt).format('DD/MM/YYYY'),
								'Lieu envol': reservation.getPlace(),
								'Prestation': (reservation.flightName) ? reservation.flightName : reservation.getFlightType().title,
								'Annulation': reservation.getCancelTime(),
								'Dernière annulation' : moment(reservation.getLastCancelTime()).format('DD/MM/YYYY'),
								'Informations': (reservation.infoReservation) ? reservation.infoReservation.replace(/;/g, ',') : '-',
							});

						}

				});

		return datas;
	}
});


export const reservationsCancelSMS = new ValidatedMethod({
	name: 'reservationsCancelSMS.export',
	validate: new SimpleSchema({
	}).validator(),
	run() {

        let datas = [];
				// let reservations = Reservations.find(
				// 	{state: {$lt: 6},
        //     history: { $elemMatch: {
        //       date: {$gte: startDate},
        //     }
        //   }, $expr: { $eq: [{ "$arrayElemAt": ["$history.type", -1] }, 'cancelled'] }}).fetch();


				let reservations = Reservations.find({
					updatedAt: {$gte: moment().subtract(15, 'days').toDate()}
				}).fetch();


				_.each(reservations, (reservation) => {

					if(reservation.history.slice(-1)[0] && reservation.history.slice(-1)[0].type == 'cancelled' && reservation.history.slice(-1)[0].date >= moment().subtract(15, 'days').toDate()) {
						reservation.passengers = reservation.getPassengers();
						datas.push(reservation);
					}


				});

		return datas;
	}
});

// Get list of all method names on Lists
const LISTS_METHODS = _.map([
	reservationsStatistics,
	reservationsExport,
	reservationsCancelExport,
	reservationsCancelSMS
], 'name');

if (Meteor.isServer) {
  // Only allow 5 list operations per connection per second
  DDPRateLimiter.addRule({
    name(name) {
      return _.includes(LISTS_METHODS, name);
    },

    // Rate limit per connection ID
    connectionId() { return true; },
  }, 5, 1000);
}



/** WEBPACK FOOTER **
 ** ./src/universal/collections/statistics/reservations.js
 **/